var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorksIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 479,
    viewBox: "0 0 239 479",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9625_80709)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.001 52.0167C113.257 52.4839 105.39 53.386 99.8178 54.0786C94.2455 54.7713 88.4391 56.6076 83.3195 59.475C77.2321 62.8899 69.2405 68.399 62.279 76.5177C55.8794 83.992 52.1177 93.4637 51.2905 103.387C50.0886 117.804 48.8087 142.143 52.3987 153.774L50.0418 327.326C50.0418 327.326 48.8712 375.474 55.9263 386.75L59.4538 414.134C59.4538 414.134 57.6901 425.41 91.2019 430.243C117.659 434.06 123.231 433.964 124.402 433.754C128.553 433.513 136.92 432.675 153.808 430.243C187.32 425.41 185.556 414.134 185.556 414.134L189.084 386.75C196.139 375.474 194.968 327.326 194.968 327.326L192.611 153.774C196.201 142.143 194.921 117.804 193.72 103.387C192.892 93.4476 189.131 83.9759 182.731 76.5177C175.77 68.3829 167.778 62.8899 161.691 59.4749C156.571 56.6076 150.983 54.7874 145.192 54.0786C139.401 53.3698 131.769 52.5 126.009 52.0329C123.668 51.8396 121.342 51.8396 119.001 52.0329L119.001 52.0167Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9625_80709",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 51,
    width: 147,
    height: 383
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.001 52.0167C113.257 52.4839 105.39 53.386 99.8178 54.0786C94.2455 54.7713 88.4391 56.6076 83.3195 59.475C77.2321 62.8899 69.2405 68.399 62.279 76.5177C55.8794 83.992 52.1177 93.4637 51.2905 103.387C50.0886 117.804 48.8087 142.143 52.3987 153.774L50.0418 327.326C50.0418 327.326 48.8712 375.474 55.9263 386.75L59.4538 414.134C59.4538 414.134 57.6901 425.41 91.2019 430.243C117.659 434.06 123.231 433.964 124.402 433.754C128.553 433.513 136.92 432.675 153.808 430.243C187.32 425.41 185.556 414.134 185.556 414.134L189.084 386.75C196.139 375.474 194.968 327.326 194.968 327.326L192.611 153.774C196.201 142.143 194.921 117.804 193.72 103.387C192.892 93.4476 189.131 83.9759 182.731 76.5177C175.77 68.3829 167.778 62.8899 161.691 59.4749C156.571 56.6076 150.983 54.7874 145.192 54.0786C139.401 53.3698 131.769 52.5 126.009 52.0329C123.668 51.8396 121.342 51.8396 119.001 52.0329L119.001 52.0167Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9625_80709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.8268 402.072C75.8268 402.072 95.8371 415.667 122.512 415.667C149.188 415.667 167.918 402.072 167.918 402.072L167.918 435.094L75.8268 435.094L75.8268 402.072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0469 402.069L75.0469 429.453L51.6339 429.453L51.6339 400.458L60.9991 400.458C60.9991 400.458 61.4673 409.753 64.1208 414.956C65.8846 418.403 68.8034 419.788 70.3643 418.177C73.486 414.956 75.0469 402.069 75.0469 402.069Z",
    fill: "#F20000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.698 402.069L168.698 429.453L192.111 429.453L192.111 400.458L182.746 400.458C182.746 400.458 182.278 409.753 179.624 414.956C177.861 418.403 174.942 419.788 173.381 418.177C170.259 414.956 168.698 402.069 168.698 402.069Z",
    fill: "#F20000"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.722 206.352C175.722 206.352 153.87 195.076 122.652 195.076C91.4349 195.076 71.1436 206.352 71.1436 206.352L64.9001 151.583C64.9001 151.583 78.9948 137.085 122.683 137.085C166.372 137.085 180.404 151.583 180.404 151.583L175.722 206.352Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5352 187.018C55.5352 187.018 38.3656 193.462 38.3656 191.851C38.3656 190.24 43.0482 170.91 53.9743 177.353C53.9743 177.353 55.5352 177.353 55.5352 187.018Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.77 187.018C189.77 187.018 206.939 193.462 206.939 191.851C206.939 190.24 202.257 170.91 191.331 177.353C191.331 177.353 189.77 177.353 189.77 187.018Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.428 160.438C187.428 160.438 190.55 369.848 182.746 382.734L178.063 371.459L179.624 215.207L187.428 160.438Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.502 160.438C58.502 160.438 55.3802 369.848 63.1846 382.734L67.8672 371.459L66.3063 215.207L58.502 160.438Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9625_80709)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.051 273.202L101.643 273.202C97.5691 273.202 93.5889 274.443 90.2018 276.762L84.0051 280.999C82.2414 282.207 80.1654 282.851 78.027 282.851L75.3423 282.851C72.2206 282.851 69.3174 281.24 67.5848 278.566L63.9948 273.009C62.1686 270.174 62.1218 266.501 63.8544 263.618L78.8543 238.859C82.4131 232.979 88.3287 229.033 94.9936 228.131C103.329 227.003 114.91 225.682 123.417 225.682C131.924 225.682 141.851 226.987 148.937 228.099C154.65 229.001 159.816 232.126 163.36 236.845L182.09 261.765C184.322 264.745 184.447 268.869 182.371 271.978L177.876 278.711C176.143 281.321 173.271 282.867 170.196 282.867L168.401 282.867C166.2 282.867 164.062 282.175 162.251 280.886L156.851 277.02C153.386 274.539 149.265 273.218 145.051 273.218L145.051 273.202Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9625_80709",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 225,
    width: 122,
    height: 58
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145.051 273.202L101.643 273.202C97.5691 273.202 93.5889 274.443 90.2018 276.762L84.0051 280.999C82.2414 282.207 80.1654 282.851 78.027 282.851L75.3423 282.851C72.2206 282.851 69.3174 281.24 67.5848 278.566L63.9948 273.009C62.1686 270.174 62.1218 266.501 63.8544 263.618L78.8543 238.859C82.4131 232.979 88.3287 229.033 94.9936 228.131C103.329 227.003 114.91 225.682 123.417 225.682C131.924 225.682 141.851 226.987 148.937 228.099C154.65 229.001 159.816 232.126 163.36 236.845L182.09 261.765C184.322 264.745 184.447 268.869 182.371 271.978L177.876 278.711C176.143 281.321 173.271 282.867 170.196 282.867L168.401 282.867C166.2 282.867 164.062 282.175 162.251 280.886L156.851 277.02C153.386 274.539 149.265 273.218 145.051 273.218L145.051 273.202Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9625_80709)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.916 276.356L136.138 243.414C135.872 240.224 133.281 237.776 130.175 237.776L115.16 237.776C112.038 237.776 109.447 240.24 109.197 243.446L106.403 278.047L138.916 278.047L138.916 276.372L138.916 276.356Z",
    fill: "#515151"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9625_80709",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 237,
    width: 33,
    height: 42
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.916 276.356L136.138 243.414C135.872 240.224 133.281 237.776 130.175 237.776L115.16 237.776C112.038 237.776 109.447 240.24 109.197 243.446L106.403 278.047L138.916 278.047L138.916 276.372L138.916 276.356Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9625_80709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.872 250.645C118.424 250.645 115.628 253.529 115.628 257.088C115.628 260.646 118.424 263.531 121.872 263.531C125.32 263.531 128.115 260.646 128.115 257.088C128.115 253.529 125.32 250.645 121.872 250.645Z",
    fill: "#878787"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.984 369.512C119.984 370.588 120.83 371.461 121.873 371.461C122.916 371.461 123.762 370.588 123.762 369.512L123.762 357.302C123.762 356.225 122.916 355.353 121.873 355.353C120.83 355.353 119.984 356.225 119.984 357.302L119.984 369.512Z",
    fill: "#C6C6C6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9625_80709",
    x: 31.9688,
    y: 33.8907,
    width: 185.072,
    height: 421.945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9625_80709"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9625_80709",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9625_80709",
    x: 44.5898,
    y: 207.68,
    width: 161.26,
    height: 97.1875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9625_80709"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9625_80709",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksIllustration);
export default __webpack_public_path__ + "static/media/how_it_works_illustration.7a9c88e9a9489e11311b1f3c0f156257.svg";
export { ForwardRef as ReactComponent };